import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GLOBAL_STORE_PROVIDER_TOKEN } from '@epicuro-next/data-providers/providers-registry';

import { GlobalStoreProviderService } from './services/global-store-provider.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: GLOBAL_STORE_PROVIDER_TOKEN,
      useClass: GlobalStoreProviderService,
    },
  ],
})
export class GlobalStoreProviderModule {}
